import { useState, useRef, useMemo } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { useReactToPrint } from "react-to-print";

const TurmaDetalhes = ({ rowData, producao_turmas, mapaTurmas, titulo }) => {
    const printRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
        documentTitle: `Relatorio Turma ${rowData.turma || 'Sem Turma'} - ${titulo}`,
    });

    const totalProduzido = useMemo(() => {
        return producao_turmas
            ?.filter(p => p.turma_id === mapaTurmas[rowData.turma])
            .reduce((acc, p) => acc + Number(p.total_metros), 0) || 0;
    }, [producao_turmas, mapaTurmas, rowData.turma]);

    const totalTurma = useMemo(() => {
        return rowData.grupos.reduce((acc, grupo) => {
            return acc + grupo.defeitos.reduce((d, item) => d + Number(item.metragem), 0);
        }, 0);
    }, [rowData.grupos]);

    return (
        <div ref={printRef} style={{ padding: "1rem 2rem" }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '1rem'
            }}>
                <div>
                    <h3 style={{ margin: 0, color: '#333' }}>
                        {rowData.turma ? `Turma ${rowData.turma}` : 'Sem Turma'}
                    </h3>

                    {rowData.turma && (
                        <p style={{ margin: '5px 0', fontWeight: 'bold', color: '#555' }}>
                            Total Produzido: {parseFloat(totalProduzido.toFixed(2)).toLocaleString("pt-BR")}m
                        </p>
                    )}

                    <p style={{ margin: '5px 0', fontWeight: 'bold', color: '#555' }}>
                        Total Defeitos: {parseFloat(totalTurma.toFixed(2)).toLocaleString("pt-BR")}m
                    </p>
                </div>

                <Button
                    className="p-button-outlined"
                    icon="pi pi-print"
                    onClick={handlePrint}
                />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '1.5rem'}}>
                {rowData.grupos.map((grupo) => {
                    const totalGrupo = grupo.defeitos.reduce((acc, d) => acc + Number(d.metragem), 0);
                    const producaoGrupo = producao_turmas?.find( p => p.turma_id === mapaTurmas[rowData.turma] && p.grupo === Number(grupo.grupo));
                    const totalProduzidoGrupo = producaoGrupo ? Number(producaoGrupo.total_metros) : null;

                    return (
                        <div key={grupo.grupo} style={{ padding: '1rem',  borderRadius: '6px', border: '1px solid #eee'}} >
                            <div style={{ fontWeight: 'bold', borderBottom: '1px solid #eee', paddingBottom: '0.5rem', marginBottom: '0.5rem', color: '#333' }}>
                                Defeitos Grupo {grupo.grupo}
                            </div>

                            {grupo.defeitos.map((d) => (
                                <div key={d.defeito} style={{ display: 'flex', justifyContent: 'space-between', padding: '0.25rem 0', fontSize: '0.9rem' }}>
                                    <span style={{ color: '#777' }}>{d.defeito}</span>
                                    <span style={{ fontWeight: '600' }}>{parseFloat(d.metragem.toFixed(2)).toLocaleString("pt-BR")}m</span>
                                </div>
                            ))}

                            <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '0.5rem', paddingBottom: '0.5rem', marginTop: '0.5rem', borderTop: '1px solid #eee', fontWeight: '600'}}>
                                <span>Total</span>
                                <span style={{color: '#7a0000'}}>{parseFloat(totalGrupo.toFixed(2)).toLocaleString("pt-BR")}m</span>
                            </div>

                            {totalProduzidoGrupo !== null && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '0.5rem', borderTop: '1px solid #eee', fontWeight: '600'}}>
                                    <span>Total Produzido</span>
                                    <span style={{color: '#00397a'}}>{parseFloat(totalProduzidoGrupo.toFixed(2)).toLocaleString("pt-BR")}m</span>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export function DefeitosTurma({ turmas, producao_turmas, titulo, producao }) {
    const mapaTurmas = useMemo(() => ({ 'A': 1, 'B': 2, 'C': 3, 'D': 4 }), []);
    const [expandedRows, setExpandedRows] = useState(null);

    return (
        <div>
            <DataTable
                value={turmas}
                expandedRows={expandedRows}
                onRowToggle={(e) => setExpandedRows(e.data)}
                dataKey="turma"
                stripedRows
                size="small"
                emptyMessage="Nenhum registro encontrado para o período selecionado."
                rowExpansionTemplate={(rowData) => (
                    <TurmaDetalhes 
                        rowData={rowData} 
                        producao_turmas={producao_turmas} 
                        mapaTurmas={mapaTurmas}
                        titulo={titulo}
                        producao={producao}
                    />
                )}
            >
                <Column
                    field="turma"
                    header="Turmas"
                    body={(rowData) => {
                        return (<Tag value={rowData.turma ? `Turma ${rowData.turma}` : 'Sem Turma'} />);
                    }}
                />
                <Column expander style={{ width: '4rem' }} />
            </DataTable>
        </div>
    )
}